import { RouteLocation } from "vue-router";
import { useBldgStore } from "../store/bldgStore";

export default (to: RouteLocation, from: RouteLocation, next: any) => {
  // Try to load building data if this is a new building
  let bldgCode = to.params.bldgCode ?? to.params.sitecode;
  if (bldgCode) {
    bldgCode = (bldgCode as string).trim().toLowerCase();
    //console.log(`Router found a siteCode param as "${bldgCode}"`);
    const bldgStore = useBldgStore();
    bldgStore.tryGetBuildingData(bldgCode);
  } else {
    console.log(" Didn't find a siteCode");
  }
  next();
  //console.log(" bldgCodeGuard ");
};
